import React, { useRef, useEffect } from 'react';

const NotesInput = ({ value, onChange }) => {
    const taRef = useRef(null);

    const resize = () => {
        const el = taRef.current;
        if (!el) return;
        el.style.height = 'auto';
        // add a few pixels so it grows slightly beyond content
        el.style.height = `${el.scrollHeight + 6}px`;
    };

    useEffect(() => {
        resize();
    }, [value]);

    const handleChange = (e) => {
        onChange(e.target.value);
        resize();
    };

    return (
        <div className="bg-white flex items-center justify-between gap-3 rounded-xl px-4 py-3">
            <div className="flex items-center gap-2 flex-1">
                <label className="text-theme_clr1 text-sm font-bold">✏️ Notes :</label>
                <textarea
                    ref={taRef}
                    placeholder="Type your notes..."
                    value={value}
                    onChange={handleChange}
                    rows={1}
                    className="flex-1 bg-theme_clr2 min-h-[18px] font-semibold rounded-3xl text-white text-center leading-tight text-xs text-nowrap px-2 py-1 focus:outline-none focus:ring-1 focus:ring-theme_clr2 resize-none overflow-hidden"
                />
            </div>
        </div>
    );
};

export default NotesInput;
